export enum PremiumType {
  COMPREHENSIVE = "COMPREHENSIVE",
  THIRD_PARTY = "THIRD_PARTY",
}
